import { createFileRoute } from '@tanstack/react-router';

function ImprintPage() {
  return (
    <article className="mx-auto max-w-3xl space-y-8">
      <header>
        <p className="font-mono text-[11px] uppercase tracking-[0.22em] text-muted-foreground">
          Legal
        </p>
        <h1 className="mt-3 text-4xl font-semibold tracking-tight">Imprint</h1>
        <p className="mt-3 text-sm text-muted-foreground">
          Information pursuant to § 5 TMG and § 18 Abs. 2 MStV.
        </p>
      </header>

      <Section title="Operator">
        <p>Lukas Schneider</p>
        <p>Winzererstr. 28</p>
        <p>80797 Munich</p>
        <p>Germany</p>
        <p className="pt-2">
          Email:{' '}
          <a
            className="underline underline-offset-4 hover:text-foreground"
            href="mailto:lu.schneider@protonmail.com"
          >
            lu.schneider@protonmail.com
          </a>
        </p>
      </Section>

      <Section title="Responsible for content per § 18 Abs. 2 MStV">
        <p>Lukas Schneider, address as above.</p>
      </Section>

      <Section title="EU online dispute resolution">
        <p>
          The European Commission provides a platform for online dispute resolution (OS):{' '}
          <a
            className="underline underline-offset-4 hover:text-foreground"
            href="https://ec.europa.eu/consumers/odr"
            target="_blank"
            rel="noreferrer"
          >
            https://ec.europa.eu/consumers/odr
          </a>
          .
        </p>
        <p>
          We are neither willing nor obliged to participate in dispute-resolution proceedings
          before a consumer arbitration board (Verbraucherschlichtungsstelle).
        </p>
      </Section>

      <Section title="Liability for content">
        <p>
          As a service provider we are responsible for our own content on these pages under
          general law (§ 7 Abs. 1 TMG). Under §§ 8 to 10 TMG we are not, however, obliged to
          monitor transmitted or stored third-party information or to investigate
          circumstances that indicate illegal activity. Obligations to remove or block the use
          of information under general law remain unaffected. Liability in this regard is
          only possible from the point in time at which a concrete infringement of the law
          becomes known. Upon notification of corresponding infringements we will remove the
          content immediately.
        </p>
      </Section>

      <Section title="Liability for links">
        <p>
          Our offer contains links to external websites of third parties over whose content
          we have no influence. We therefore cannot accept any liability for this external
          content. The respective provider or operator of the linked pages is always
          responsible for their content. The linked pages were checked for possible legal
          violations at the time of linking. Illegal content was not recognisable at that
          time. A permanent content control of the linked pages is, however, unreasonable
          without concrete indications of an infringement. Upon notification of violations we
          will remove such links immediately.
        </p>
      </Section>
    </article>
  );
}

function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <section className="space-y-3">
      <h2 className="text-lg font-semibold">{title}</h2>
      <div className="space-y-2 text-[15px] leading-relaxed text-muted-foreground">
        {children}
      </div>
    </section>
  );
}

export const Route = createFileRoute('/imprint')({
  component: ImprintPage,
});
